/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "7c2de0a37be3ee76b715b25da699f38895d420c6";
